import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2NercRegionDelete,
  wind2NercRegionUpdate,
  getWind2NercRegion,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'

const Wind2NercRegion = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 300px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Region Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Region Code :</Label> */}
        <Input
          value={insertData.regionCode}
          data-cy="regioncode"
          onChange={e =>
            setInsertData({
              ...insertData,
              regionCode: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Region Name :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Region Name :</Label> */}
        <Input
          value={insertData.regionName}
          data-cy="regionname"
          onChange={e =>
            setInsertData({
              ...insertData,
              regionName: e.target.value,
            })
          }
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }
  return (
    <CommonScreen
      title="NERC Region"
      header={headers}
      sortOptions={headers}
      saveTask={wind2NercRegionUpdate}
      retrieveTask={getWind2NercRegion}
      deleteTask={wind2NercRegionDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={900}
      // heightOffset={100}
    />
  )
}

export default Wind2NercRegion

const headers = [
  strCol({
    ident: 'regionCode',
    display: 'Region Code',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'regionName',
    display: 'Region Name',
    isKey: true,
    width: 350,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]
